<script lang="ts">
	import { goto } from '$app/navigation';
	import { hasTextContent } from '$lib/html/input/richtextarea-front';

	import RichTextarea from '$lib/html/input/RichTextarea.svelte';
	import { t } from '$lib/stores/i18n';
	import WidgetButton from '$lib/widget/components/WidgetButton.svelte';
	import WidgetPage from '$lib/widget/components/WidgetPage.svelte';
	import { gotoFirstStep } from '$lib/widget/flow';
	import {
		clearCacheAvails,
		newWidgetBooking,
		widgetBooking,
		widgetBookingExpiresAt,
		widgetConfig,
		widgetContent
	} from '$lib/widget/stores';
	import { onMount } from 'svelte';

	let hasGiftcards = $derived($widgetContent.giftcards.length > 0);
	let hasWelcomeContent = $derived(hasTextContent($widgetConfig.customContent.welcome));
	let hasActivities = $derived($widgetContent.activities.length > 0);

	let loaded = false;
	onMount(() => {
		if (hasActivities && !hasGiftcards && !hasWelcomeContent) {
			gotoWidget(true);
			return;
		}

		loaded = true;

		setTimeout(() => {
			highlightGiftcard = true;
			setTimeout(() => {
				highlightGiftcard = false;
			}, 500);
		}, 2000);
	});

	function gotoGiftcards() {
		loaded = false;
		goto(`/widget/${$widgetConfig.hash}/giftcards`);
	}

	function gotoWidget(replaceState: boolean = false) {
		// Reset booking state
		$widgetBookingExpiresAt = undefined;
		$widgetBooking = newWidgetBooking();
		clearCacheAvails();

		loaded = false;
		gotoFirstStep(replaceState);
	}

	let highlightGiftcard = $state(false);
	let showGiftcardImage = false;
</script>

<WidgetPage hideRestartButton>
	{#if hasWelcomeContent}
		<p class="mt-10 mb-16 whitespace-pre-line">
			<RichTextarea readonly value={$widgetConfig.customContent.welcome} />
		</p>
	{/if}

	<div class="mt-10 mb-4 flex flex-col gap-4">
		{#if hasActivities}
			<div class="mx-auto w-72 h-fit">
				<WidgetButton
					icon="calendar"
					className="w-full sm:w-72 mx-auto"
					onclick={() => gotoWidget()}
				>
					{$t('widget-external.start_button')}
				</WidgetButton>
			</div>
		{:else}
			<p class="mt-10 mb-16 whitespace-pre-line text-pretty">
				{$t('widget-external.no_activities')}
			</p>
		{/if}

		{#if hasGiftcards}
			<button
				class="mx-auto w-72 h-fit"
				onclick={() => {
					gotoGiftcards();
				}}
			>
				<div class="{showGiftcardImage ? '-mt-6 px-4' : ''} w-full">
					<WidgetButton
						backgroundImage={showGiftcardImage ? '/giftcard-button.webp' : ''}
						zoom={highlightGiftcard}
						height="h-10"
						icon="giftcard"
						className="w-full mx-auto"
						onclick={gotoGiftcards}
					>
						{$t('widget-external.giftcards_button')}
					</WidgetButton>
				</div>
			</button>
		{/if}
	</div>
</WidgetPage>
